import { render, staticRenderFns } from "./modeOfDisposal.vue?vue&type=template&id=34eb1978&scoped=true&"
import script from "./modeOfDisposal.vue?vue&type=script&lang=js&"
export * from "./modeOfDisposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34eb1978",
  null
  
)

export default component.exports